<script>
import { Button } from 'ant-design-vue'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  methods: {
    onClick() {
      if (this.item.onClick) {
        this.item.onClick()
      }
    }
  },
  render() {
    return (
      <Button
        props={this.item.props}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '3px',
          ...(this.item.props || {}).style
        }}
        {...this.item.props}
        onClick={() => this.onClick()}
      >
        {this.item.label}
      </Button>
    )
  }
}
</script>
